import React, { useState } from 'react';
import './login.css'
import {useHistory, Link} from 'react-router-dom';
import axios from 'axios';
import LoadingBar from 'react-top-loading-bar'
import logo from '../../images/SuperSeva_Logo_white.png'

import { Button, Modal, Form } from 'react-bootstrap';
import UserDetailsSelect from './UserDetailsSelect.js'

const Login=(props)=>{
    const [data, setdata]=useState({username:'', password:''})
    const [err, seterr]=useState({})
    const history=useHistory()
    const [progress, setProgress] = useState(0)

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [useDetails, setuserDetails]=useState({})
    
    const LoginClick=()=>{
        axios.post('/login', {
            username:data.username,
            password:data.password
        },{onUploadProgress:(ev)=>{
            setProgress((ev.loaded / ev.total) * 100)
        }}).then((res)=>{
            if(res.data.status==="err"){
                // console.log(res.data)
                alert(res.data.msg)
            }else{                              
                console.log(props.login_not)
                try{
                    if(props.login_not){
                        // props.closeModalIfLogiIn(res.data)
                    }else{
                        // onClick={handleShow}
                        console.log(res.data)
                        setuserDetails(res.data)
                        handleShow()
                        // history.replace("/");
                        // history.go(0);
                    }
                    
                }
                catch(err){
                    // history.replace("/");      
                    // history.go(0);
                    console.log(err)
                }
               
            }
        })
    }
    const handlesubmit=(ev)=>{
        ev.preventDefault()
        let err={}
        if(data.username===''){
            err.email='Please Enter username'
        }
        if(data.password===''){
            err.password='Please Enter password'
        }
        seterr({...err})
         if(Object.keys(err).length===0){
            // localStorage.setItem('login', true)
            // history.go(0)
            // history.replace('/')
            LoginClick()
        }
    }
    return(
        <><div>
    <div className="wrapper fadeInDown">
    <LoadingBar
    color='#f11946'
    progress={progress}
    onLoaderFinished={() => setProgress(0)}       
  />
    <div id="formContent">

        <div className="fadeIn" style={{
            display:'flex',justifyContent:'center', alignItems:'center',
            padding:20
        }}>
            <img src={logo} id="icon" alt="User Icon" />  
        </div>
        <div style={{paddingLeft:10, paddingRight:10}}>
            <form action='/' onSubmit={handlesubmit}>
                <div>
                    <label>Email or Phone</label>
                    <input type="text" id="login" value={data.username}
                    onChange={(ev)=>{
                        setdata({...data, username:ev.target.value})
                        seterr({...err, email:''})
                    }} className="fadeIn second" name="login" placeholder="Email"/>
                    {err.email&&
                    <span style={{color:'red'}}>{err.email}</span>}
                </div>
                <div>
                    <label>Password</label>
                    <input type="password"  value={data.password}
                    onChange={(ev)=>{
                        setdata({...data, password:ev.target.value})
                        seterr({...err, password:''})
                    }}
                    id="password" className="fadeIn third" name="login" placeholder="Password"/>
                    {err.password&&
                    <span style={{color:'red'}}>{err.password}</span>}
                </div>
                <div>
                    <span style={{
                        fontSize:12
                    }}>By proceeding, I agree to the Terms Of Service and Privacy Policy.</span>
                </div>
                <div>
                    <Button type='submit' variant='primary' className="fadeIn fourth my-3" value="Sign In"  style={{width:"80px", height:"35px", color:"white"}} >Sign In </Button>
                </div>
                </form>
        </div>

<div >
        <div id="formFooter">
<table>
<tr>
      <td>   <div style={{marginRight:"100%"}}> 
         <a className="underlineHover" href='http://superseva.cloud1.parashmis.in/'> BackEnd SignUp? </a>
         </div></td>
      <td></td>
          <td style={{paddingLeft:"70%"}}>  <div>
                <a className="underlineHover" href="#">Forgot Password?</a>
            </div>
            <div>
                <Link className="underlineHover" to={{
                                    pathname:"/signup",
                                    state:props.propsStateData
                                }}>SignUp?</Link>
            </div></td> </tr> </table>
        </div>
</div>
    </div>
  

    </div>



    <Modal show={show} onHide={handleClose} id="formContent" style={{marginTop:"12%", boxShadow:"",  borderRadius: "15px 15px 15px 15px",background:"transparent"}}>
        <Modal.Header style={{border:"none"}} >
          <Modal.Title><img src={logo} alt="SuperSeva.png" 
        className="superseva-logo"              
       style={{
         width:'65%', marginLeft:"17%"
       }} /> </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        
        <UserDetailsSelect userData={useDetails}  />

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {/* <Button variant="primary" onClick={handleClose}>
            Logout
          </Button> */}
        </Modal.Footer>
      </Modal>

    {/* <Button variant="primary" onClick={handleShow} type="submit" >
        Launch demo modal
      </Button> */}


    </div></>
    )
}
export default Login;